import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { RevisionEntry } from './revisionModel';
import { revisionMakerText } from './revisionFactText';
import { revisionMessages } from './revisionMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './Revisions.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface RevisionComparePicksProps {
  entries: RevisionEntry[];
  keys: string[];
  currentUserId: number | null;
  onToggle: (key: string) => void;
}

/** The check boxes of Compare (design d2). A revision with no file shows "No file to compare" and cannot be checked. */
const RevisionComparePicksComponent: React.FC<RevisionComparePicksProps> = ({
  entries,
  keys,
  currentUserId,
  onToggle,
}) => {
  const intl = useIntl();
  return (
    <div className="d-flex flex-column gap-2">
      {entries.map((entry) => {
        const canPick = entry.state === 'ready';
        const who = canPick
          ? revisionMakerText(intl, entry, currentUserId)
          : intl.formatMessage(revisionMessages.compareNoFile);
        return (
          <label
            key={entry.key}
            htmlFor={`revision-pick-${entry.key}`}
            className={clsx(styles.pick, !canPick && styles.pickOff)}
          >
            <input
              id={`revision-pick-${entry.key}`}
              type="checkbox"
              checked={keys.includes(entry.key)}
              disabled={!canPick}
              onChange={() => onToggle(entry.key)}
            />
            <b>{intl.formatMessage(revisionMessages.number, { number: entry.number })}</b>
            <span>{who}</span>
          </label>
        );
      })}
    </div>
  );
};

export const RevisionComparePicks = TypedMemo(RevisionComparePicksComponent);
